var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "cargo-ag-grid", style: _vm.gridStyle },
    [
      _c("ag-grid-vue", {
        ref: "cargoAgGrid",
        staticClass: "ag-theme-balham",
        class: [_vm.showSelectedColor ? "showSelectedColor" : ""],
        style: "width: 100%;flex:1;min-height: " + _vm.minHeight,
        attrs: {
          "locale-text-func": _vm._i18nGridLocalText,
          "grid-options": _vm.gridOptions,
          "row-data": _vm.rowData,
          "side-bar": _vm.showSideBar ? _vm.defaultSideBar : null,
          "get-main-menu-items": _vm.getMainMenuItems,
          "process-cell-for-clipboard": _vm.onProcessCellForClipboard,
          "row-height": _vm.gridOptions.rowHeight || 29,
          "allow-drag-from-columns-tool-panel": true,
          "enable-browser-tooltips": true
        },
        on: {
          "cell-context-menu": _vm.cellEventCallback,
          "grid-ready": _vm.onReady,
          "row-drag-end": _vm.rowDragEndCallback,
          "cell-clicked": _vm.cellEventCallback,
          displayedColumnsChanged: _vm.onGridDisplayedColumnsChanged,
          columnResized: _vm.onGridColumnsChanged,
          "row-data-changed": _vm.onRowDataChanged,
          "row-data-updated": _vm.onRowDataUpdated,
          cellValueChanged: _vm.onCellValueChanged,
          "filter-changed": _vm.onFilterChanged,
          "sort-changed": _vm.onSortChanged,
          "cell-focused": _vm.onCellFocused,
          rowGroupOpened: _vm.onRowGroupOpened,
          expandOrCollapseAll: _vm.onExpandOrCollapseAll,
          columnRowGroupChanged: _vm.onColumnRowGroupChanged,
          selectionChanged: _vm.onSelectionChanged
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }